import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const P360_ASSORTMENT_NAMESPACE = `${PARTNER360_NAMESPACE}/assortment`

export const REQUEST_ASSORTMENT_CATEGORIES = `${P360_ASSORTMENT_NAMESPACE}/requestAssortmentCategories`
export const REQUEST_ASSORTMENT_GROUPS = `${P360_ASSORTMENT_NAMESPACE}/requestAssortmentGroups`
export const REQUEST_ASSORTMENT_ITEMS = `${P360_ASSORTMENT_NAMESPACE}/requestAssortmentItems`

export const REQUEST_DELETE_ASSORTMENT_GROUP = `${P360_ASSORTMENT_NAMESPACE}/requestDeleteAssortmentGroup`
export const REQUEST_DELETE_ASSORTMENT_ITEM = `${P360_ASSORTMENT_NAMESPACE}/requestDeleteAssortmentItem`

export const REQUEST_SAVE_ASSORTMENT_GROUP = `${P360_ASSORTMENT_NAMESPACE}/requestSaveAssortmentGroup`
export const REQUEST_SAVE_ASSORTMENT_ITEM = `${P360_ASSORTMENT_NAMESPACE}/requestSaveAssortmentItem`

export const REQUEST_SAVE_ASSORTMENT_GROUPS_SORT_ORDER = `${P360_ASSORTMENT_NAMESPACE}/requestSaveAssortmentGroupsSortOrder`
export const REQUEST_SAVE_ASSORTMENT_ITEMS_SORT_ORDER = `${P360_ASSORTMENT_NAMESPACE}/requestSaveAssortmentItemsSortOrder`
